import { useDashboardTour } from "../../../hooks/apptours"
import { useSetHeaderTitle } from "../../../hooks/hooks"

export const useHome = () => {
  useSetHeaderTitle('Home')
  useDashboardTour()
}